import { SET_SQP_VIEW_TYPE } from 'seller/store/saga/amazonTraffic';

const initialState = {
  viewType: 'general_performance'
};
export const amazonTrafficSettingsSelector = state => state.amazonTrafficSettings;

const amazonTrafficSettings = (state = initialState, action) => {
  switch (action.type) {
    case SET_SQP_VIEW_TYPE: {
      return { ...state, viewType: action.payload };
    }

    default: {
      return state;
    }
  }
};

export default amazonTrafficSettings;
